module.exports = __webpack_public_path__ + "img/a33f2b6.svg";